import { useTranslation } from 'react-i18next'

import { ArrowUDownLeftIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import Statistic from '@/common/components/Statistic/Statistic'
import { viewIds } from '@/returns/pages/TransactionsPage/constants'

const CurrentMonthRefunds = ({ refunds, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      Icon={ArrowUDownLeftIcon}
      label={t('Devoluciones')}
      value={<AnimatedNumber target={refunds} format="decimal" />}
      onClick={() => onClick(viewIds.lastThirtyDaysRefunds)}
    />
  )
}

export default CurrentMonthRefunds
